/**
 * @name 渲染表单组件
 */
import base from '../../base';
import AbElectronicDocument from './Electronic-document';
import Upload from '../upload';
import UploadTree from '../uploadTree';
AbElectronicDocument.install = function(Vue) {
  Vue.use(base);
  Vue.component(AbElectronicDocument.name, AbElectronicDocument);
  Vue.component(Upload.name, Upload);
  Vue.component(UploadTree.name, UploadTree);
};

export default AbElectronicDocument;
